module.exports = __webpack_public_path__ + "h5/img/promoter.4643a39e.png";